export default "__VITE_ASSET__DHmFwPnd__"